import React, { useState } from 'react';
import { Unit } from '../../../helpers/unit';
const unit = Unit.getInstance();
const speedIcon = require("../../../../assets/images/speed_meter.svg");


export const TruckSpeedPopover = (data) => {
    const isRequesting = (data && data.data) ? data.data["isRequesting"] : false;
    const speedShortName = (data && data.speedShortName) ? data["speedShortName"] : null;
    const { max_speed, avg_speed } = (data && data.data && data.data.speedData) ? data.data.speedData : { max_speed: 0, avg_speed: 0 };

    const [isOpen, setIsOpen] = useState(false);
    const handleClick = () => {
        setIsOpen(!isOpen);
    };

    return (
        <div className='truckspeed_popover'>
            <img className={`pr-1 ${isOpen ? 'active' : ''}`} onClick={handleClick} style={{ cursor: 'pointer', width: '25px', lineHeight: '0' }} src={speedIcon} alt="Speed Icon" />

            {isOpen && (
                <div>
                    {isRequesting ?
                        <div className='popover'>
                            <div className="arrow"></div>
                            <div>Loading...</div>
                        </div>
                        : (max_speed > 0 && avg_speed > 0) ? (
                            <div className='popover'>
                                <div className="arrow"></div>
                                <div className='my-1 truck-speed' style={{ color: 'red' }}>
                                    <strong>{unit.toRoundOfSpeed(max_speed)} {speedShortName} | Max</strong>
                                </div>
                                <div className='my-1 truck-speed' style={{ color: 'green' }}>
                                    <strong>{unit.toRoundOfSpeed(avg_speed)} {speedShortName} | Average</strong>
                                </div>
                            </div>
                        ) : (
                            <div className='popover' style={{color: 'red' }}><div className="arrow"></div>Unknown</div>
                        )}
                </div>
            )}
        </div>
    );
}